import React from 'react';

import { Cards, CountryPicker, Chart } from './components';
import { fetchData } from './api/';
import styles from './App.module.css';

import image from './images/image.png';

class App extends React.Component {
  state = {
    data: {},
    country: '',
  }

  async componentDidMount() {
    const data = await fetchData();

    this.setState({ data });
  }

  handleCountryChange = async (country) => {
    const data = await fetchData(country);

    this.setState({ data, country: country });
  }

  render() {
    const { data, country } = this.state;

    return (
      <div className={styles.container}>
        {/*<!-- <img className={styles.image} src={image} alt="COVID-19" /> */}
        <h1>COVID-19 Insights</h1>
        <h3 className={styles.dropDownHeading}>
          Please select a country (By default, insights are provided at the global level)
        </h3>
        <CountryPicker data={data} handleCountryChange={this.handleCountryChange} />
        <br />
        <Cards data={data} country={country} />
        
        <br />
        <Chart data={data} country={country} /> 
      </div>
    );
  }
}

export default App;